// extracted by mini-css-extract-plugin
export var icon = "_af-3";
export var subtitle = "_af-2";
export var title = "_af-1";
export var value = "_af-0";